import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { settings } from '../../settings';

type ReqParams = { [param: string]: string };
type Headers = {
  Authorization: string;
  'X-API-KEY': string;
  'Content-Type': string;
};

@Injectable({
  providedIn: 'root',
})
export class StandardHttpProvider {
  constructor(private httpClient: HttpClient) {}

  request(method: string, url: string, headers: Headers, params?: ReqParams, body?: any): Promise<any> {
    const options = {
      body,
      headers,
      reportProgress: false,
      observe: <any>'response',
      params,
      responseType: <any>'json',
      withCredentials: false,
    };

    return this.httpClient.request(method, url, options).pipe(timeout(settings.http.timeoutMs)).toPromise();
  }
}
